export default __webpack_public_path__ + "static/media/arrowLeftIcon.1235bc8a.svg";